import { fetchDataFromURL } from '../api/fetchDataFromURL';
import ActionTypes from './types';

/** @param {import('../typings').HomePageState} props */
export const fetchOptionTradeAction = (props) => async (dispatch) => {
  try {
    const {
      selectedGroupCallValue,
      toggleNoSpreads,
      currentDate,
      toggleRemoveWeeks,
      selectedResultCallValue,
      toggleOnlyAtm,
    } = props;

    await dispatch({
      type: ActionTypes.SET_APP_STATE,
      payload: {
        weekendErrors: null,
        loading: true,
      },
    });

    const data = await fetchDataFromURL(
      `/api/get-firsthometable-data?group=${selectedGroupCallValue}&date=${currentDate}&limit=${selectedResultCallValue}&removeWeeks=${toggleRemoveWeeks}&onlyAtm=${toggleOnlyAtm}&noSpreads=${toggleNoSpreads}`
    );
    if (data && data.length) {
      dispatch({
        type: ActionTypes.SET_APP_STATE,
        payload: {
          weekendErrors: null,
          homeFirstTable: data,
          loading: false,
        },
      });
    } else {
      dispatch({
        type: ActionTypes.SET_APP_STATE,
        payload: {
          weekendErrors: "Can't Get Data Might be Weekend or Holiday",
          homeFirstTable: [],
          loading: false,
        },
      });
    }
  } catch (error) {
    dispatch({
      type: ActionTypes.SET_APP_STATE,
      payload: {
        weekendErrors: "Can't Get Data Might be Weekend or Holiday",
        homeFirstTable: [],
        loading: false,
      },
    });
  }
};



// WEBPACK FOOTER //
// ./src/actions/optionTradeAction.js